<template>
  <div class="col-12 d-flex flex-column align-items-center p-0 m-0">
    <div
      class="col-12 d-flex flex-column align-items-center p-0 m-0"
      v-if="!eliminarRegistro"
    >
      <div class="text-confir my-4">
        ¿Estás segura/o de asignarle a la bodega <b>{{ pointsale.name }}</b> el
        <b>{{ scenario.name }}</b> ?
      </div>
      <div class="mt-3 d-flex">
        <SaveModal @click="$emit('editar')" :loading="loadingSave">
          Sí, estoy seguro
        </SaveModal>
        <PreviusEditModal @click="$emit('cancelar')" :loading="loadingPrevius">
          No, seguir editando
        </PreviusEditModal>
      </div>
    </div>

    <div
      class="col-12 d-flex flex-column align-items-center p-0 m-0"
      v-if="eliminarRegistro"
    >
      <div class="my-4">
        <span class="text-danger-confir">{{ textMsgConfirmar }}</span>
      </div>
      <div class="mt-2 d-flex">
        <PreviusEditModal @click="$emit('cancelar')" :loading="loadingEdit">
          Seguir Editando
        </PreviusEditModal>
        <DelModal :loading="loadingDel" @click="$emit('eliminar')">
          Borrar {{ textDel }}
        </DelModal>
      </div>
    </div>
  </div>
</template>
<script>
import SaveModal from "@/components/core/button/save-modal.vue";
import DelModal from "@/components/core/button/del-modal.vue";
import PreviusEditModal from "@/components/core/button/previus-edit-modal.vue";
export default {
  name: "tipspointsale-show",
  components: { SaveModal, PreviusEditModal, DelModal },
  props: {
    textDel: {
      default: "",
      type: String,
    },
    loadingSave: {
      default: false,
      type: Boolean,
    },
    loadingEdit: {
      default: false,
      type: Boolean,
    },
    loadingPrevius: {
      default: false,
      type: Boolean,
    },
    loadingDel: {
      default: false,
      type: Boolean,
    },
    pointsale: {
      type: Object,
      default: null,
    },
    scenario: {
      type: Object,
      default: null,
    },
    eliminarRegistro: {
      default: false,
      type: Boolean,
    },
  },
  emits: ["guardar", "cancelar", "editar", "eliminar"],
  data() {
    return {
      id: null,
      name: null,
      linedealid: null,
      linedeal: {
        id: "",
        name: "",
      },
      textMsgConfirmar: "Al confirmar no podrás recuperar los cambios",
    };
  },
};
</script>
<style lang="scss">
.text-danger-confir {
  color: #da1414;
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
}
.text-confir {
  font-family: "Ubuntu" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 20px !important;
  text-align: center !important;
  color: #455a64 !important;
}
</style>